import "./single.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";

const Single = () => {
  return (
    <div className="single">
      <Sidebar />

      <div className="singleContainer">
        {/* <Navbar /> */}

        <div className="content">
          <div className="profileCard">
            <h2 className="cardTitle">Contact Information</h2>

            <div className="profile">
              <img className="profileImage" src="/img/logo.png" alt="Profile" />

              <div className="profileDetails">
                <h3 className="name">Lokendra Phagami Pun</h3>

                <div className="info">
                  <span>Email</span>
                  <p>merogaunonline@gmail.com</p>
                </div>

                <div className="info">
                  <span>Phone</span>
                  <p>+977 9806685014</p>
                </div>

                <div className="info">
                  <span>Address</span>
                  <p>Pokhara , Fulbari</p>
                </div>

                <div className="info">
                  <span>Country</span>
                  <p>Nepal</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Single;
